import Item from './Item';

export default class Ball extends Item {
  constructor({ game, location, data }) {
    super({ game, location, data });
    this.jumpTimes = [0.7, 0.4, 0.2];
    this.jumpHeights = [75, 30, 10];
    this.squizeTimes = [0.2, 0.2, 0.15];
    this.squizeValues = [0.15, 0.15, 0.03];
  }

  hitGround() {
    if (!this.jump) {
      this.jump = true;
      this.squize = false;
      this.jumpY = this.y;
      this.jumpCount = 0;
      this.jumpAngle = 0;
      this.jumpTime = this.jumpTimes[this.jumpCount];
      this.jumpHeight = this.jumpHeights[this.jumpCount];
    }
  }

  handleInputDown(target, pointer) {
    this.jump = false;
    super.handleInputDown(target, pointer);
  }

  step(dt) {
    super.step(dt);

    if (this.jump) {
      if (this.squize) {
        this.jumpAngle += dt / this.squizeTimes[this.jumpCount];
        if (this.jumpAngle >= 1) {
          // go to next jump or end it
          this.squize = false;
          this.jumpAngle = 0;
          this.jumpCount++;
          if (this.jumpCount === 3) {
            this.jump = false;
          } else {
            this.jumpTime = this.jumpTimes[this.jumpCount];
            this.jumpHeight = this.jumpHeights[this.jumpCount];
          }
        }
        //
        if (this.jump) {
          const sin = Math.sin(Math.PI * this.jumpAngle);
          const val = this.squizeValues[this.jumpCount];
          this.scale.y = this.scale.x * (1 - val * sin);
        } else {
          this.scale.y = this.scale.x;
        }
        this.y = this.jumpY;
        this.dz = 0;
      } else {
        this.jumpAngle += dt / this.jumpTime;
        if (this.jumpAngle >= 1) {
          this.jumpAngle = 0;
          this.squize = true;
        }
        if (this.jumpCount < 3) {
          const sin = Math.sin(Math.PI * this.jumpAngle);
          const dy = -this.jumpHeight * this.jumpTime * sin;
          this.y = this.jumpY + dy;
          this.dz = -dy;
        } else {
          this.y = this.jumpY;
          this.dz = 0;
        }
      }
    }
  }
}
